import React from "react";
import { CommunityStyle } from "../styles/community.style";
import useMediaQuery from "../hooks/useMediaQuery";
import facebookIcon from '../assets/images/facebook.svg';
import mediumIcon from '../assets/images/medium.svg';
import radditIcon from '../assets/images/raddit.svg';
import telegramIcon from '../assets/images/telegram.svg';
import twitterIcon from '../assets/images/twitter.svg';

const Community = () => {
  const communityFrame =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627796/mad_wallet/images/community/mdw__community-head.png";
  const communityBox =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627796/mad_wallet/images/community/community-social-mini-panel.png";
  const communityBg =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1649982065/mad_wallet/images/community/community_page_mad_wallet_DONE_1080_copy.jpg";
  const communityFrameMb =
    "https://res.cloudinary.com/dahddvlgy/image/upload/v1651182997/mad_wallet/images/mobile/Panels/community-panel.png";

  const matches = useMediaQuery("(max-width: 768px)");

  return (
    <CommunityStyle id="community" bg={communityBg}>
      <div className="community__content">
        <div className="community__content--container">
          <img
            src={matches ? communityFrameMb : communityFrame}
            alt="community access"
          />
          <p className="community__content--text">
            Here we love to do things differently because we now live in a
            different world. Join us if you think you are different.
          </p>
        </div>
        <div className="community--box">
          <div className="community--box__container">
            <a
              className="community--box__icon"
              href="https://web.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            ><img src={facebookIcon} alt="join facebook community" /></a>
            <div className="community--box-img__container">
              <img src={communityBox} alt="community pannel" />
            </div>
          </div>
          <div className="community--box__container">
            <a
              className="community--box__icon"
              href="https://medium.com/"
              target="_blank"
              rel="noopener noreferrer"
            ><img src={mediumIcon} alt="our blog" /></a>
            <div className="community--box-img__container">
              <img src={communityBox} alt="community pannel" />
            </div>
          </div>
          <div className="community--box__container">
            <a
              className="community--box__icon"
              href="https://www.reddit.com/"
              target="_blank"
              rel="noopener noreferrer"
            ><img src={radditIcon} alt="ask questions" /></a>
            <div className="community--box-img__container">
              <img src={communityBox} alt="community pannel" />
            </div>
          </div>
          <div className="community--box__container">
            <a
              className="community--box__icon"
              href="https://www.telegram.com/"
              target="_blank"
              rel="noopener noreferrer"
            ><img src={telegramIcon} alt="join us on telegram" /></a>
            <div className="community--box-img__container">
              <img src={communityBox} alt="community pannel" />
            </div>
          </div>
          <div className="community--box__container">
            <a
              className="community--box__icon"
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
            ><img src={twitterIcon} alt="follow us on twitter" /></a>
            <div className="community--box-img__container">
              <img src={communityBox} alt="community pannel" />
            </div>
          </div>
        </div>
      </div>
    </CommunityStyle>
  );
};

export default Community;
